<template>
  <component
    :is="props.to ? NuxtLink : 'button'"
    :to="props.to || undefined"
    type="button"
    :class="[
      'flex items-center px-4 gap-2 h-11 py-2.5 rounded cursor-pointer transition-all text-base relative no-underline w-full text-left',
      {
        'text-gray-100 font-semibold bg-gray-750 border-l-2 border-primary': props.active,
        'text-gray-300 font-normal hover:bg-gray-725': !props.active
      }
    ]"
  >
    <div class="gap-2 flex items-center flex-1">
      <Icon
        v-if="props.prependIcon"
        :name="props.prependIcon"
        :class="[
          'h-5 w-5 transition-all shrink-0',
          {
            'text-gray-300': !props.active,
            'text-gray-100': props.active
          }
        ]"
      />
      {{ props.label }}
    </div>

    <!-- Badge count -->
    <span
      v-if="props.badgeCount !== undefined && props.badgeCount > 0"
      class="inline-flex items-center justify-center min-w-5 h-5 px-1.5 bg-gray-575 border border-border-segment rounded-full text-xs font-medium text-gray-100"
    >
      {{ props.badgeCount > 9 ? '9+' : props.badgeCount }}
    </span>
  </component>
</template>

<script setup lang="ts">
import { NuxtLink } from '#components';

interface Props {
  label: string;
  prependIcon?: string;
  active?: boolean;
  to?: string;
  badgeCount?: number;
}

const props = defineProps<Props>();
</script>
